import { GlButton, GlTooltipDirective as GlTooltip } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { hide } from '../../tooltips/index.js?vue3';
export default {
    name: 'ToggleFocus',
    components: {
        GlButton
    },
    directives: {
        GlTooltip
    },
    data () {
        return {
            isFullscreen: false
        };
    },
    methods: {
        toggleFocusMode () {
            hide(this.$refs.toggleFocusModeButton);
            const issueBoardsContent = document.querySelector('.js-content-panels');
            issueBoardsContent?.classList.toggle('is-focused');
            this.isFullscreen = !this.isFullscreen;
        }
    },
    i18n: {
        toggleFocusMode: __('Toggle focus mode')
    }
};
